import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import LoaderSpiner from "../../../../components/loaderSpiner";
import { useLazyGetNationalityCompositionQuery } from "../../../../services/Api";

const COLORS = [
  "#5D733C", "#F2D53F", "#F2994A", "#56CCF2", "#BB6BD9",
  "#EB5757", "#27AE60", "#2F80ED", "#9B51E0", "#F4A261",
  "#264653", "#E76F51", "#8D99AE", "#06D6A0", "#118AB2",
  "#EF476F", "#8338EC", "#3A86FF", "#FB5607", "#FF006E"
];

export default function NationalityComposition() {
  const [trigger, { data, isLoading, error }] =
    useLazyGetNationalityCompositionQuery();
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    trigger()
      .unwrap()
      .then((response) => {
        if (response?.success) {
          const nationalityStats = response?.data || [];
          const formattedData = nationalityStats.map((item) => ({
            name:
              item.label.charAt(0).toUpperCase() +
              item.label.slice(1).toLowerCase(),
            value: item.value,
          }));
          setChartData(formattedData);
        } else {
        }
      })
      .catch((err) => {
      });
  }, [trigger]);

  if (isLoading) {
    return <LoaderSpiner />;
  }

  if (error) {
    return <p>Error loading data. Please try again later.</p>;
  }

  return (
    <div className="bg-lightgreen p-6 rounded-[1.75rem] h-full flex flex-col">
      <h3 className="text-lg font-roboto-mono text-[18px] font-bold self-start">
        Nationality Composition
      </h3>

      {/* Centered Chart and Legend */}
      <div className="flex flex-col items-center justify-center flex-grow">
        {/* Chart Section */}
        <div className="relative flex justify-center items-center w-[250px] h-[250px]">
          <PieChart width={200} height={200}>
            <Pie
              data={chartData}
              innerRadius={60}
              outerRadius={80}
              paddingAngle={0}
              dataKey="value"
            >
              {chartData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip
              contentStyle={{
                backgroundColor: "#F9FAFB",
                color: "#333",
                borderRadius: "8px",
                padding: "8px",
                fontSize: "14px",
              }}
              labelStyle={{
                fontWeight: "bold",
                fontSize: "14px",
              }}
              formatter={(value) => `${value}%`}
            />
          </PieChart>
          <div className="absolute flex flex-col justify-center items-center inset-0">
            <p className="text-2xl font-bold">100%</p>
          </div>
        </div>

        {/* Legend Section */}
        <div className="flex flex-wrap justify-center gap-4 mt-4">
          {chartData.map((entry, index) => (
            <div key={entry?.name} className="flex items-center gap-2">
              <div
                className="w-3 h-3 rounded-full"
                style={{ backgroundColor: COLORS[index % COLORS.length] }}
              ></div>
              <span className="text-sm">{entry?.name}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

}
